// extracted by mini-css-extract-plugin
export default {"container":"videoPlayerModal_container__ggqcX","player":"videoPlayerModal_player__w3VFy"};